import { Key } from '@app/utils/keys';
import { Switcher } from '@typings';
import React from 'react';

interface Props<T> {
  tabs: Switcher.Tab<T>[];
  selectedTabKey: T;
  onChange: (selectedValue?: T) => void;
}
export const useContentSwitcherKeyboardHandler = <T extends string | undefined>({ tabs, selectedTabKey, onChange }: Props<T>) => {
  const [currentFocusedValue, setCurentFocusedValue] = React.useState<string | undefined>(selectedTabKey);

  React.useEffect(() => {
    setCurentFocusedValue(selectedTabKey);
  }, [selectedTabKey]);

  const handleArrowLeftKey = (event: React.KeyboardEvent) => {
    event.stopPropagation();
    event.preventDefault();

    const currentIndex = tabs.findIndex(tab => tab.value === currentFocusedValue);
    const previousIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    const previousItemValue = tabs[previousIndex]?.value;
    onChange(previousItemValue);
    setCurentFocusedValue(previousItemValue);
  };

  const handleArrowRightKey = (event: React.KeyboardEvent) => {
    event.stopPropagation();
    event.preventDefault();

    const currentIndex = tabs.findIndex(tab => tab.value === currentFocusedValue);
    const nextIndex = (currentIndex + 1) % tabs.length;
    const nextItemValue = tabs[nextIndex]?.value;
    onChange(nextItemValue);
    setCurentFocusedValue(nextItemValue);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    const handlers: Record<string, Maybe<(event: React.KeyboardEvent) => void>> = {
      [Key.LEFT]: handleArrowLeftKey,
      [Key.RIGHT]: handleArrowRightKey,
    };

    handlers[event.code]?.(event);
  };

  return {
    currentFocusedValue,
    handleKeyDown,
  };
};
